import { createContext, useContext } from 'react';
export var SubtitleContext = /*#__PURE__*/createContext(undefined);
export var useSubtitleContext = function useSubtitleContext() {
  var context = useContext(SubtitleContext);
  if (context === undefined) {
    throw new Error('useSubtitleContext must be used within a SubtitleProvider component');
  }
  return context;
};